import { Link } from 'react-router';
import { Minus, Plus, Trash2 } from 'lucide-react';
import { Button } from '@dzseguidores/ui';
import { formatBRL, useCartStore } from '@/stores/cart-store';
import { useProducts } from '@/hooks/use-catalog';
import { OrderBumpOffer } from '@/components/cro/featured-catalog';
import { TrustBar } from '@/components/cro/trust-bar';
import { useSeo } from '@/hooks/use-seo';

export function CartPage() {
  const { items, updateQuantity, removeItem, totalCents } = useCartStore();
  const { data } = useProducts();
  const catalog = data?.items ?? [];

  useSeo({
    title: 'Carrinho',
    description: 'Revise seu pedido de seguidores e curtidas e finalize com PIX na DZ Seguidores.',
    path: '/carrinho',
    noindex: true,
  });

  if (items.length === 0) {
    return (
      <div className="container-page py-16 text-center">
        <h1 className="text-2xl font-semibold">Seu carrinho está vazio</h1>
        <p className="mt-2 text-muted">Explore o catálogo e adicione serviços.</p>
        <Link to="/catalogo" className="mt-6 inline-block">
          <Button>Ir ao catálogo</Button>
        </Link>
      </div>
    );
  }

  return (
    <div className="container-page py-10">
      <h1 className="text-2xl font-semibold">Carrinho</h1>
      <p className="mt-1 text-sm text-muted">Revise os pacotes e aproveite o order bump abaixo.</p>

      <div className="mt-8 grid gap-8 lg:grid-cols-[1fr_320px]">
        <div>
          <ul className="space-y-4">
            {items.map((item) => (
              <li
                key={item.id}
                className="glass flex items-center justify-between gap-4 rounded-xl p-4"
              >
                <div>
                  <p className="font-medium">{item.name}</p>
                  <p className="text-sm text-muted">
                    {formatBRL(Number(item.priceCents))} / pacote
                  </p>
                </div>
                <div className="flex items-center gap-2">
                  <button
                    type="button"
                    className="rounded-lg p-1 hover:bg-surface"
                    onClick={() => updateQuantity(item.id, item.quantity - 1)}
                    aria-label="Diminuir"
                  >
                    <Minus className="h-4 w-4" />
                  </button>
                  <span className="w-8 text-center text-sm">{item.quantity}</span>
                  <button
                    type="button"
                    className="rounded-lg p-1 hover:bg-surface"
                    onClick={() => updateQuantity(item.id, item.quantity + 1)}
                    aria-label="Aumentar"
                  >
                    <Plus className="h-4 w-4" />
                  </button>
                  <button
                    type="button"
                    className="rounded-lg p-1 text-muted hover:text-fg"
                    onClick={() => removeItem(item.id)}
                    aria-label="Remover"
                  >
                    <Trash2 className="h-4 w-4" />
                  </button>
                </div>
              </li>
            ))}
          </ul>

          <OrderBumpOffer catalog={catalog} />
        </div>

        <aside className="glass h-fit rounded-2xl p-6">
          <p className="text-sm text-muted">Total</p>
          <p className="mt-1 text-2xl font-semibold">{formatBRL(totalCents())}</p>
          <p className="mt-2 text-xs text-muted">Sem taxas ocultas · PIX ou cartão</p>
          <Link to="/checkout" className="mt-6 block">
            <Button className="w-full" size="lg">
              Finalizar compra
            </Button>
          </Link>
          <div className="mt-6">
            <TrustBar compact />
          </div>
        </aside>
      </div>
    </div>
  );
}
